import React, { useState } from 'react';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../contexts/AuthContext';
import AdminLayout from '../../components/AdminLayout';
import PasswordInput from '../../components/PasswordInput';

const s = {
  header: { marginBottom: '32px' },
  title: { fontFamily: "'Inter', sans-serif", fontSize: '34px', fontWeight: 700, color: 'var(--text)' },
  titleSpan: { fontStyle: 'italic', color: 'var(--accent)' },
  card: { background: 'var(--surface)', border: '1px solid var(--divider)', borderRadius: 'var(--r-card)', padding: '28px', maxWidth: '460px', boxShadow: 'var(--sh-card)' },
  cardTitle: { fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '18px' },
  label: { fontSize: '11px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-2)', display: 'block', marginBottom: '6px' },
  field: { marginBottom: '14px' },
  input: { width: '100%', padding: '10px 14px', border: '1.5px solid var(--divider)', borderRadius: 'var(--r-input)', fontSize: '14px', color: 'var(--text)', background: 'var(--bg)', outline: 'none', fontFamily: "'Inter', sans-serif" },
  msg: { padding: '10px 14px', borderRadius: 'var(--r-btn)', fontSize: '13px', marginBottom: '14px' },
  submitBtn: { width: '100%', padding: '12px', border: 'none', borderRadius: 'var(--r-btn)', fontSize: '13px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', cursor: 'pointer', fontFamily: "'Inter', sans-serif" },
};

export default function MeuPerfil() {
  const { user } = useAuth();
  const [form, setForm] = useState({ nova: '', confirmar: '' });
  const [msg, setMsg] = useState(null);
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (form.nova !== form.confirmar) {
      setMsg({ type: 'error', text: 'As senhas não coincidem.' });
      return;
    }
    if (form.nova.length < 6) {
      setMsg({ type: 'error', text: 'A senha deve ter pelo menos 6 caracteres.' });
      return;
    }
    setSaving(true);
    setMsg(null);
    const { error } = await supabase.auth.updateUser({ password: form.nova });
    if (error) {
      setMsg({ type: 'error', text: error.message });
    } else {
      setMsg({ type: 'success', text: 'Senha atualizada com sucesso!' });
      setForm({ nova: '', confirmar: '' });
    }
    setSaving(false);
  }

  return (
    <AdminLayout>
      <div style={s.header}>
        <h1 style={s.title}>Meu <span style={s.titleSpan}>perfil</span></h1>
      </div>

      <div style={s.card}>
        <div style={s.cardTitle}>Dados da conta</div>
        <div style={{ fontSize: '14px', color: 'var(--text)', marginBottom: '4px' }}>{user?.name}</div>
        <div style={{ fontSize: '13px', color: 'var(--text-2)', marginBottom: '20px' }}>{user?.email}</div>

        <div style={s.cardTitle}>Redefinir senha</div>
        <form onSubmit={handleSubmit}>
          <div style={s.field}>
            <label style={s.label}>Nova senha</label>
            <PasswordInput
              style={s.input}
              value={form.nova}
              onChange={e => setForm(f => ({ ...f, nova: e.target.value }))}
              placeholder="Mínimo 6 caracteres"
            />
          </div>
          <div style={s.field}>
            <label style={s.label}>Confirmar senha</label>
            <PasswordInput
              style={s.input}
              value={form.confirmar}
              onChange={e => setForm(f => ({ ...f, confirmar: e.target.value }))}
              placeholder="Repita a nova senha"
            />
          </div>
          {msg && (
            <div style={{ ...s.msg, background: msg.type === 'error' ? 'rgba(229,57,53,0.07)' : 'rgba(76,175,80,0.08)', color: msg.type === 'error' ? '#C62828' : '#2E7D32', border: `1px solid ${msg.type === 'error' ? 'rgba(229,57,53,0.2)' : 'rgba(76,175,80,0.3)'}` }}>
              {msg.text}
            </div>
          )}
          <button
            type="submit"
            disabled={saving || !form.nova || !form.confirmar}
            style={{ ...s.submitBtn, background: form.nova && form.confirmar ? 'var(--text)' : 'rgba(37,28,25,0.12)', color: form.nova && form.confirmar ? '#FAF7F2' : 'var(--text-2)', cursor: form.nova && form.confirmar ? 'pointer' : 'not-allowed' }}
          >
            {saving ? 'Salvando...' : 'Atualizar senha'}
          </button>
        </form>
      </div>
    </AdminLayout>
  );
}
